import { Box, styled, Typography } from '@mui/material';
import arca from '../assets/login-arca.png';
import anses from '../assets/login-anses.png';

const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '44px',
  border: '1px solid ',
  borderColor: theme.palette.grey[300],
  borderRadius: 2,
  cursor: 'pointer',
  marginBottom: '.725rem',
}));
interface ButtonProps {
  title: string;
  handleClick: () => void;
}

export default function LoginButton(props: ButtonProps) {
  const { title, handleClick } = props;

  return (
    <ButtonWrapper onClick={() => handleClick()}>
      <img
        src={title === 'ARCA' ? arca : anses}
        style={{
          maxWidth: '100%',
          height: 'auto',
          marginRight: '1rem',
          width: title === 'ARCA' ? '75px' : 'auto'
        }}
      />

      <Typography variant={'body2'} sx={{ textAling: 'center' }}>
        Continuar desde {title}
      </Typography>
    </ButtonWrapper>
  );
}
